import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Modal as ModalComponent } from '@digsup/components-modal';
import { Text } from '@digsup/components-text';
import { styles } from './Modal.scss';

const cx = classNames.bind(styles);

export const Modal = ({
  isOpen,
  onRequestClose,
  title,
  subtitle,
  className,
  children,
  ...props
}) => (
  <ModalComponent
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    spacing="large"
    size="auto"
    overlayClassName="c-pricing-plans-modal-overlay"
    className={cx('c-pricing-plans-modal', className)}
    {...props}>
    <div className="u-margin-bottom-xlarge-stretched">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 80 80"
        width={80}
        height={80}
        className="u-display-block u-margin-right-auto u-margin-left-auto u-margin-bottom-large">
        <path fill="#fcf8d0" d="M40 0A40 40 0 110 40 40 40 0 0140 0z" />
        <path
          fill="#f3b65a"
          d="M55.56 36.22v16.11a5.43 5.43 0 01-5.5 5.33h-8.5c1.9-2.9 1.9-12.03 1.9-12.11a.64.64 0 01.64-.64h3.14a1.59 1.59 0 001.11-2.71l-6.93-6.3a1.64 1.64 0 00-2.28 0l-6.93 6.3a1.59 1.59 0 001.12 2.71h3.14a.65.65 0 01.64.64c0 .08 0 9.2 1.9 12.11h-8.5a5.41 5.41 0 01-5.5-5.33V36.26a3.11 3.11 0 01.94-2.27l12.9-12.24a2.53 2.53 0 013.61.01l5.77 5.78v-2.88a1.22 1.22 0 011.2-1.22h2.48a1.22 1.22 0 011.2 1.22v7.8l1.54 1.53a3.25 3.25 0 01.9 2.23z"
        />
      </svg>
      <Text
        size="2xs"
        fontFamily="serif"
        fontWeight="semibold"
        marginBottom="none">
        {title}
      </Text>
      <Text>{subtitle}</Text>
    </div>
    {children}
  </ModalComponent>
);

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
};

Modal.defaultProps = {
  isOpen: false,
  className: '',
};
